import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { ProductVariant } from "../../../domain/projections/Wishlist";
import { financial } from "../shared/util/financial/financial";
import { PROJECT, TrackingEventName, ViewWishlistTrackingEvent } from "./tracking";

interface TrackViewWishlistFunctionArgs {
  readonly products: ProductVariant[];
}

interface TrackViewWishlistFunction {
  (args: TrackViewWishlistFunctionArgs): void;
}

interface UseTrackViewWishlistFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackViewWishlistFunction {
  (agrs: UseTrackViewWishlistFunctionArgs): TrackViewWishlistFunction;
}

const useTrackViewWishlist: UseTrackViewWishlistFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<ViewWishlistTrackingEvent>();

  const trackViewWishlist: TrackViewWishlistFunction = useCallback(
    ({ products }) => {
      emitUserEvent({
        event: TrackingEventName.VIEW_WISHLIST,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        ecommerce: {
          products: products.map((variant: ProductVariant) => ({
            ...variant,
            price: financial(variant.price.amount),
          })),
        },
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackViewWishlist;
};

export { useTrackViewWishlist };
